import { dispatchThunk } from "./dispatchThunk";
import { OPEN_CONTACT } from "./chat/contacts/Types";
import { loadChatMessageHistory } from "./chat/messages/Actions";

var loadChatHistoryMiddleware = function loadChatHistoryMiddleware(store) {
  return function (next) {
    return function (action) {
      var result = next(action);
      var a = action;

      switch (a.type) {
        case OPEN_CONTACT:
          {
            var contact = a.contact;
            var h = contact.messageHistoryInfo;

            if (h.hasMoreMessages && h.loadedMessageCount === 0) {
              dispatchThunk(store, loadChatMessageHistory(contact));
            }

            break;
          }

        default:
          break;
      }

      return result;
    };
  };
};

export default loadChatHistoryMiddleware;